<template>
<div v-if="loading_data === false" 
    class="content"
    :class="[{
        'parent-issue': (issue.parent_issue_id == null), 
        'sub-issue': (issue.parent_issue_id !== null)}, 
        issue.slug
    ]"
    >
    
    <div v-if="issue.display_summary == 1 && !isThemeSection" class="summary-wrapper">
        <template v-if="['entrepreneurship','realclearunicorns'].indexOf(issue.slug) === -1">
            <div v-if="issue.parent_issue_id === null" class="summary-heading">Summary:</div>
            <div v-else class="summary-heading">Introduction:</div> 
        </template>
        <div class="summary" v-if="issue.summary_lead && (issue.name !=='State-Based K-12 Education Reforms' && issue.name !=='State-Based Solutions for a Healthier US')">
            <span v-show="issue.summary_lead && !show_full_summary" v-html="issue.summary_lead"></span>
            <span v-show="issue.summary_lead && show_full_summary" v-html="issue.summary"></span>
            <span v-show="!issue.summary_lead" v-html="issue.summary"></span>
            <free-speech-widget v-if="issue.slug === 'free_speech_on_campus'" />
        </div>
        <div class="summary" v-if="!issue.summary_lead && (issue.name !=='State-Based K-12 Education Reforms' && issue.name !=='State-Based Solutions for a Healthier US')">
            <span v-html="issue.summary"></span>
        </div>
        <div class="summary" v-if="issue.name == 'State-Based K-12 Education Reforms'">
            <span><p>From approving charter schools to creating education savings accounts to reducing learning pod and homeschooling laws, states are pursuing a variety of education reforms to expand education opportunity and empower parents.</p></span>
        </div>
        <div class="summary" v-if="issue.name == 'State-Based Solutions for a Healthier US'">
            <span><p>We can all agree healthcare is broken and needs to be fixed. The solutions for how to achieve that can already be found at the state level. From telehealth to direct primary care to expanding scope of practice, states are exploring healthcare solutions that will improve healthcare quality, access, and costs for years to come.</p></span>
        </div>
        <div v-if="issue.has_sub_issues_menu == 1" class="sub-issues-section" >
            <hr/>
            <template v-if="issue.custom_sub_issues_menu !== null && issue.custom_sub_issues_menu.length > 0" >
                <p v-html="issue.custom_sub_issues_menu" ></p>
            </template>
            <p v-else-if="menu_list_sub_issues.length > 0" >
                To go deeper into the subjects covered by this online library, visit the following subportals:
                <ul class="sub-issues-ul" itemscope itemtype="https://schema.org/BreadcrumbList" >
                    <li v-for="(sub_issue, index) in menu_list_sub_issues" 
                        :key="sub_issue.id" class="sub-issues-li"
                        itemprop="itemListElement" itemscope
                        itemtype="https://schema.org/ListItem" >
                        <a :href="sub_issue_link(sub_issue)"
                            itemprop="item">
                            <span itemprop="name" v-html="sub_issue_link_name(sub_issue, index)" ></span>
                            </a>
                        <meta itemprop="position" :content="(index+1)" />
                    </li>
                </ul>
            </p>
        </div>
    </div><!-- END .summary-wrapper DIV -->

    <div v-if="featured_story" :id="`featured-story-${featured_story.id}`" class="featured-story-wrapper">
        <div class="featured-heading">
            <h3 class="section-heading">Featured Story</h3>
        </div>
        <div class="featured-story">
            <div class="featured-story-image">
                <a :href="featured_story.url" :target="hrefTarget">
                    <img :src="getFeaturedImage()" class="featured-story-img" />
                </a>
            </div>
            <div class="featured-story-content">
                <div class="featured-story-title">
                    <a :href="featured_story.url" :target="hrefTarget">{{ featured_story.title}}</a>
                </div>
                <div class="featured-story-summary" > {{featured_story.excerpt }} </div>
                <div class="read_more">
                    <a :href="featured_story.url" :target="hrefTarget">
                        <span class="read_more_text" >Read More</span>
                        <i class="fas fa-external-link-alt read_more_icon"></i>
                    </a>
                </div>
            </div>
        </div>
    </div><!--End of featured story-->

    <form class="mailchimp_newsletter_signup_form" v-if="issue.mailchimp_audience_id" @submit.prevent="mailchimp_newsletter_signup"
        :class="{ mailchimp_newsletter_signup_form_success: newsletter_response }" >
        <label v-if="!newsletter_response" class="mailchimp_newsletter_signup_label" for="mailchimp_newsletter_signup">Sign up for the <strong>{{issue.name}} Newsletter</strong></label>
        <input v-if="!newsletter_response" v-on:keyup="clear_button" class="mailchimp_newsletter_signup_input" name="mailchimp_newsletter_signup" type="email" v-model="mailchimp_newsletter_signup_email" placeholder="Enter your Email Address" :disabled="submitting" />
        <div class="mailchimp_newsletter_signup_input_wrapper" v-if="!newsletter_response">
            <button type="submit" v-bind:class="[{ mailchimp_newsletter_signup_button: mailchimp_newsletter_signup_email }, mailchimp_newsletter_signup_hidden, mailchimp_newsletter_signup_button_enabled]" :disabled="newsletter_response || !confirm_tos">Submit</button>
            <img class="submit-fix" v-show="submitting" src="/asset/img/alchemy_spinner.gif" alt="Loading" height="19" width="19">
        </div>
        <div v-if="mailchimp_newsletter_signup_email && !newsletter_response" class="confirm_tos">
            <input id="confirm_tos" name="confirm_tos" type="checkbox" v-model="confirm_tos" @click="toggle_submit_button"  >
            <label for="confirm_tos">I agree to <a href="https://www.realclearpolitics.com/privacy.html">Privacy Policy</a> and <a href="https://www.realclearpolitics.com/terms_of_service.html">Terms of Service</a></label>
        </div>
        <div>
            <p class="submit-message" v-if="submitted" v-html="submit_message"></p>
        </div>
    </form>
    <!-- Begin Mailchimp Signup Form -->

    <div class="mc-partner-nl" v-if="issue.slug == 'state_solutions' ">
        <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css">
        <div id="mc_embed_signup">
            <form action="https://spn.us4.list-manage.com/subscribe/post?u=e107e46f9142699b1727e0b0c&amp;id=5b946b9e7a" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                <div id="mc_embed_signup_scroll">
                    <label for="mce-EMAIL">Get the latest state policy insights and innovations delivered straight to your inbox.</label>
                    <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required>
                    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_e107e46f9142699b1727e0b0c_5b946b9e7a" tabindex="-1" value=""></div>
                    <div class="clear">
                        <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
                    </div>
                </div>
            </form>
        </div>
    </div><!--End mc_embed_signup-->

    <div id="insticator-container" class="embedid-980f3cb3-4221-4792-9008-ac9e379f4fec">
        <div id="insticator-embed"></div>
        <!-- <script data-cfasync='false' type="text/javascript"></script> -->
    </div>

    <filter-posts
        v-if="issue.tag_filter === 1 || issue.state_selector_visible === 1" 
        :tags-selector-visible="issue.tag_filter == 1" 
        :state-selector-visible="issue.state_selector_visible == 1" 
        :issue="issue_basic"
        :posts="posts" 
        :sections="issue.sections" 
        :tags="issue.tags"
        :states="issue.pa_states"
        @posts-filtered="sections => {setFilteredPosts(sections)}"
        /><!-- end filter-posts -->

    <!-- force two columns for any issue matching -->
    <div v-if="['entrepreneurship','realclearunicorns'].indexOf(issue.slug) > -1">

        <template v-for="(group, group_index) in twoColStructure" >
            
            <div 
                class="two-col-wrapper" 
                :key="`${group_index}-two-col`"  >

                <component  
                    v-for="(section, s_index) in group"
                    :key="`${section.id}-${s_index}-section`" 
                    :is="getSectionComponent(section)" 
                    :section="section" 
                    :issue="issue_basic"
                    :ref="`${section.slug}_ref`"
                    @toggle-overlay="value => {overlay_is_active = value;}" 
                    class="two-col-limit"
                    />
            
            </div>

        </template>

    </div>

    <!-- parent issue -->
    <template v-else-if="issue.parent_issue_id == null" >

        <template v-for="(section, s_index) in issue.sections" >

            <template v-if="s_index < 1" >
                <top-sections 
                    :key="`${section.id}-top-section`" 
                    :sections="issue.sections" 
                    :issue="issue_basic"
                    ref="top-sections"
                    @toggle-overlay="value => {overlay_is_active = value;}" />
            </template>
            
            <component v-else-if="s_index > 1" 
                :key="`${section.id}-section`" 
                :is="getSectionComponent(section)" 
                :section="section" 
                :issue="issue_basic"
                :ref="`${section.slug}_ref`"
                @toggle-overlay="value => {overlay_is_active = value;}" />

        </template>
    </template>

    <!-- EAD theme section content -->
    <template v-else-if="isThemeSection">
        <div class="two-col-wrapper-sub-issue">
            <template>
                <component
                    :is="getSectionComponent(themeSection)"
                    :section="themeSection"
                    :issue="issue_basic"
                />
            </template>
        </div>
    </template>

    <!-- EAD menu -->
    <template v-else-if="themeList.includes(issue.id) && !isThemeSection">
        <div class="two-col-wrapper-sub-issue">
            <template>
                <component  
                    :is="getThemeContentButtons()"
                    :section="issue.sections[0]"
                    :issue="issue_basic"
                /> 
            </template>
        </div>
    </template>
    
    <!-- sub issue section -->
    <template v-else >
        <div class="two-col-wrapper-sub-issue">
            <template v-for="(section, s_index) in issue.sections" >
                <component  
                    :key="`${section.id}-${s_index}-section`" 
                    :is="getSectionComponent(section)" 
                    :section="section" 
                    :issue="issue_basic"
                    :ref="`${section.slug}_ref`"
                    @toggle-overlay="value => {overlay_is_active = value;}" />
            </template>
        </div>
    </template>

    <!-- Public Affairs :: Archives  -->
    <section v-if="issue.parent_issue_id === null" class="archives">
        <h3 class="section-heading">Archives</h3>
        <div v-if="display_results_from == 1" class="inside">
            <label>Results from:</label>
            <select name="inside" v-model="inside">
                <option v-for="select_issue in all_issues" :key="select_issue.id" :value="select_issue.id">Issue: {{ select_issue.name }}</option>
                <option value="site">All of Site</option>
            </select>
        </div> 
        <div class="search-wrapper"> 
            <div class="search-input">
                <input type="text" name="search" placeholder="Search" v-model="search" @keyup.enter="get_search_results()" />
                <div class="magnifier" @click="get_search_results()"></div> 
            </div>
            <div class="filter">
                <label>Filter:</label>
                <label>
                    <input name="show_all" id="show_all" type="checkbox" @change="checkAll()" v-model="isCheckAll"> All 
                </label>
                &nbsp;<span v-for="(type) in filterTypes" :key="type">
                    <label><input type="checkbox" v-bind:value="type" v-model="filters" @change="updateCheckall()"> {{ type }} </label>
                </span>
            </div>
        </div>
        <div class="pagination" v-if="show_pagi">{{Math.min(pagiTotal, archives_per_load*page_control)}} out of {{pagiTotal}}</div>
        <div v-if="loading_archives" class="loading_pa"></div>
        <div class="archives-listings-wrapper">
            <div class="archive-item" v-for="(archs) in archive_items" :key="archs.title">
                <div class="title">
                    <a :href="archs.url" :target="hrefTarget"> <span class="type">[{{display_type(archs)}}]</span> {{archs.title}}</a>
                </div>
                <div class="link">
                    <a :href="archs.url" :target="hrefTarget">{{archs.url}}</a>
                </div>
                <div class="excerpt">
                    <p>
                        {{archs.excerpt}}
                    </p>
                </div>
            </div>
        </div> <!--End of wrapper-->
        <div class="load-more" @click="loadArchives" v-if="(archives_per_load*page_control <= pagiTotal) && !loading_archives">Load More</div>
        <div v-if="loading_archives" class="loading_pa_2"></div>
    </section> <!--End of section archives-->

    <!--Modal-->
    <div v-if="overlay_is_active == true" class="overlay"></div>

    <template v-if="open_mc_embeded_form">
        <div @click="close_mc_embeded_modal" class="mc-modal-underlay"></div>
        <div class="mc-modal-container">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title" v-show="this.mailchimp_newsletter_signup_email == '' ">
                        <div class="modal-title-text"><h3>Enter your email address to subscribe</h3></div>
                    </div>
                    <div class="modal-close">
                        <div @click="close_mc_embeded_modal" class="close-icon right">&#x2715;</div>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="mc-modal-preselect-msg">We preselected all newsletters you had before unsubscribing.</div>
                    <div class="modal-body-text">
                        <!-- Begin Mailchimp Signup Form --> 
                        <div id="mc_embed_signup"> 
                            <form @submit="mc_embedded_submit" action="https://realclearpolitics.us7.list-manage.com/subscribe/post?u=61572bb8acf7b8704903af7b8&amp;id=036f88a1e3" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate> 
                                <div id="mc_embed_signup_scroll"> 
                                    <div class="indicates-required" v-show="this.mailchimp_newsletter_signup_email == '' "><span class="asterisk">*</span> indicates required</div> 
                                    <div class="mc-field-group email" v-show="this.mailchimp_newsletter_signup_email == '' "> 
                                        <label for="mce-EMAIL">Email Address  <span class="asterisk">*</span> 
                                        </label> 
                                        <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL"  v-model="this.mailchimp_newsletter_signup_email"> 
                                    </div> 
                                    <div class="mc-field-group input-group"> 
                                        <strong>Newsletters </strong> 
                                        <ul class="newsletters_container">
                                            <li v-for="item in mc_newsletters" :key="item.interest_id"> 
                                                <input type="checkbox" :value="item.value" :name="item.name_attribute" :id="item.id" :data-interest-id="item.interest_id">
                                                <label :for="item.id">{{item.name}}</label> 
                                            </li>
                                        </ul>
                                    </div> 
                                    <div class="mouse_scroll"> 
                                        <div class="mouse"> 
                                            <div class="wheel"></div> 
                                        </div> 
                                        <div> 
                                            <span class="m_scroll_arrows one"></span> 
                                            <span class="m_scroll_arrows two"></span> 
                                            <span class="m_scroll_arrows three"></span> 
                                        </div> 
                                    </div> 
                                    <div style="position: absolute; left: -5000px;" aria-hidden="true">
                                        <input type="text" name="b_61572bb8acf7b8704903af7b8_036f88a1e3" tabindex="-1" value=""><!--real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                                    </div>  
                                    <div class="clear">
                                        <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button btn btn-submit">
                                    </div> 
                                </div> 
                            </form> 
                            <div class="subscribe_txt" style="display:none">
                                <span>Thanks for Subscribing!</span> 
                            </div> 
                        </div> 
                        <!--End mc_embed_signu</link>p--> 
                    </div>
                </div>
            </div>
        </div>
    </template>
</div><!-- END : .content DIV -->

</template>

<script>
import PaCommonMixin from './PaCommonMixin.js';

const FreeSpeechWidget = () => import(/* webpackChunkName: "PaFreeSpeechWidget" */ "./FreeSpeechWidget.vue");
const FilterPosts = () => import(/* webpackChunkName: "PaFilterPosts" */ "./FilterPosts.vue");
const TopSections = () => import(/* webpackChunkName: "PaTopSections" */ "./TopSections.vue");

//LOAD VUE APP & TRIGGER DYNAMIC RE-WRITE
var issue = {};      //Initial Items loaded by default - "6 out of 21"
var all_issues_data = [];
var archive_data = {}; //data returned from executing search for term/phrase
var search_data = {}; //new data obj that will loop through all solr results and push to initial array above
var vue_loaded = false; //needed??
//var page_control = 1; //controls pagination for search results - used in Search.offset
var data_url = 'index.json'; //URL const used in AJAX calls to get X Data
var index_issue_basic = 'index_issue_basic.json'; //URL const used in AJAX calls to get X Data
// var all_issues_url = '/public_affairs/issues.json';
var all_issues_url = '/public_affairs/issues.json';

var date = new Date();
var cache_bust = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDay() + '-' + date.getHours() + '-' + date.getMinutes();

export default {
    name: 'public-affairs-app',
    components: {
        'free-speech-widget': FreeSpeechWidget,
        'filter-posts': FilterPosts,
        'top-sections': TopSections,
    },
    mixins: [
        PaCommonMixin,
    ],
    data: function () {
        return {
            // EAD portal themes
            themeList: [56,57,58,59,60,61,62],
            isThemeSection: false,
            themeSection: {},

            //public affairs app globals
            //in the news globals
            // news_items_per_load: 13,
            // news_index: 8, // $d.sections[1].item_limit,
            // show_news_loader: true,
            //essential reading globals
            // reading_items_per_load: 5,
            // reading_index: 8, // $d.sections[0].item_limit,

            // Limits the amount of american stories on a page load
            // american_stories_default_quantity: 3, // $d.american_stories_limit || 3,

            // Stores the state of the American Stories Loader
            // show_american_stories_loader: true,

            // The number of stories to load when the American Stories Loader is clicked
            // american_stories_items_per_load: 5,

            // show_reading_loader: true,
            //videos and charticles globals
            // vnc_items_per_load: 9,
            // vnc_index: 9, // $d.sections[2].item_limit,
            // show_vnc_loader: true,
            
            //search globals
            search: '',
            //archive globals
            archives_per_load: 25,
            pagiTotal: 0,
            show_pagi: false,
            page_control: 1,
            loading_archives: false,

            //filter checkboxes globals
            isCheckAll: true,
            filterTypes: ['summary', 'charticle', 'article', 'video'],
            filters: ['summary', 'charticle', 'article', 'video'],
            selectedFilter: '',
            inside: 0, // $d.id,
            archive_items: [],
            display_results_from: null, // $d.display_results_from,

            //data collection/definition
            // summary: null, // $d.summary,
            // summary_lead: null, // $d.summary_lead,
            // custom_sub_issues_menu: null, // $d.custom_sub_issues_menu || null,
            // has_sub_issues_menu: 0, // $d.has_sub_issues_menu || 0,
            // all_data: {}, // $d,
            // id: 0, // $d.id,
            // issue_name: null, // $d.name,
            // issue_slug: null, // $d.slug,
            
            // reading_items: [],
            // news_items: [],
            // vnc_items: [],
            // american_stories: [],
            // reading_items_section: {},
            // news_items_section: {},
            // vnc_items_section: {},
            // american_stories_section: {},
            // all_issues: [], // $i,
            
            // display_summary: null, // $d.display_summary,
            // display_branding: null, // $d.display_branding,
            
            // tag_filter: 0, // parseInt($d.tag_filter),
            // tags: [], // $d.tags || [],
            
            // sections: [], // $d.sections,

            
            featured_story: null,
            // mailchimp_audience_id: null, // $d.mailchimp_audience_id,
            overlay_is_active: false,
            embed_src: '',
            options: '',
            mailchimp_newsletter_signup_email: '',
            submitted: false,
            newsletter_response: false,
            submitted_already_subscribed: false,
            newsletter_tos: 'I agree to our Privacy Policy and Terms of Service',
            submit_message: '',
            mailchimp_newsletter_signup_hidden: 'mailchimp_newsletter_signup_hidden',
            submitting: false,
            confirm_tos: false,
            mailchimp_newsletter_signup_button_enabled: '',
            states: [],
            // sub_issues: [],
         
            issue: {},
            issue_basic: {},
            loading_data: false,
            all_issues: [],// REVERT BEFORE PROD
            posts: [],
            // all_posts: [],

            //summary globals
            show_full_summary: false,
            summaryLabel: 'Show More',

            //mc embeded form globals
            open_mc_embeded_form: false,
            user_newsletters: [],
            //to add a new newsletter to the list you need to go to mailchimp
            //and and click on "Audience" and then "Signup forms"
            //select embedded forms and do as if you were adding a form 
            //get to the step where you see the the embed code and get the data from there
            mc_newsletters: [
                {
                    value: 1,
                    name_attribute: 'group[5973][1]',
                    id: 'mce-group[5973]-5973-0',
                    for_attribute: 'mce-group[5973]-5973-0',
                    name: 'Carl M. Cannon\'s Morning Note',
                    interest_id: '0978b16ed7'
                },
                {
                    value: 2,
                    name_attribute: 'group[5973][2]',
                    id: 'mce-group[5973]-5973-1',
                    for_attribute: 'mce-group[5973]-5973-1',
                    name: 'RCP Today',
                    interest_id: 'b6df7a5a47'
                },
                {
                    value: 4,
                    name_attribute: 'group[5973][4]',
                    id: 'mce-group[5973]-5973-2',
                    for_attribute: 'mce-group[5973]-5973-2',
                    name: 'RCP Takeaway',
                    interest_id: 'b0e1454bd9'
                },
                {
                    value: 8,
                    name_attribute: 'group[5973][8]',
                    id: 'mce-group[5973]-5973-3',
                    for_attribute: 'mce-group[5973]-5973-3',
                    name: 'RCP Events',
                    interest_id: '17b0333591'
                },
                {
                    value: 16,
                    name_attribute: 'group[5973][16]',
                    id: 'mce-group[5973]-5973-4',
                    for_attribute: 'mce-group[5973]-5973-4',
                    name: 'Defense Morning Recon',
                    interest_id: '4be11a1ba6'
                },
                {
                    value: 32,
                    name_attribute: 'group[5973][32]',
                    id: 'mce-group[5973]-5973-5',
                    for_attribute: 'mce-group[5973]-5973-5',
                    name: 'Science News',
                    interest_id: '7c94a2a355'
                },
                {
                    value: 64,
                    name_attribute: 'group[5973][64]',
                    id: 'mce-group[5973]-5973-6',
                    for_attribute: 'mce-group[5973]-5973-6',
                    name: 'Energy Morning Volt',
                    interest_id: '698c52111c'
                },
                {
                    value: 128,
                    name_attribute: 'group[5973][128]',
                    id: 'mce-group[5973]-5973-7',
                    for_attribute: 'mce-group[5973]-5973-7',
                    name: 'World News',
                    interest_id: '131071d6c4'
                },
                {
                    value: 256,
                    name_attribute: 'group[5973][256]',
                    id: 'mce-group[5973]-5973-8',
                    for_attribute: 'mce-group[5973]-5973-8',
                    name: 'Education Today',
                    interest_id: 'a957e8b6b1'
                },
                {
                    value: 512,
                    name_attribute: 'group[5973][512]',
                    id: 'mce-group[5973]-5973-9',
                    for_attribute: 'mce-group[5973]-5973-9',
                    name: 'Health Morning Scan',
                    interest_id: '834d157b5f'
                },
                {
                    value: 1024,
                    name_attribute: 'group[5973][1024]',
                    id: 'mce-group[5973]-5973-10',
                    for_attribute: 'mce-group[5973]-5973-10',
                    name: 'Policy',
                    interest_id: '49df3ce58e'
                },
                {
                    value: 2048,
                    name_attribute: 'group[5973][2048]',
                    id: 'mce-group[5973]-5973-11',
                    for_attribute: 'mce-group[5973]-5973-11',
                    name: 'Religion Today',
                    interest_id: 'b54e369263'
                },
                {
                    value: 4096,
                    name_attribute: 'group[5973][4096]',
                    id: 'mce-group[5973]-5973-12',
                    for_attribute: 'mce-group[5973]-5973-12',
                    name: 'Books Today',
                    interest_id: 'e1222b54d5'
                },
                {
                    value: 8192,
                    name_attribute: 'group[5973][8192]',
                    id: 'mce-group[5973]-5973-13',
                    for_attribute: 'mce-group[5973]-5973-13',
                    name: 'History Today',
                    interest_id: '75efb6c7ae'
                },
                {
                    value: 16384,
                    name_attribute: 'group[5973][16384]',
                    id: 'mce-group[5973]-5973-14',
                    for_attribute: 'mce-group[5973]-5973-14',
                    name: 'Markets Today',
                    interest_id: '81822f7ea3'
                },
                {
                    value: 32768,
                    name_attribute: 'group[5973][32768]',
                    id: 'mce-group[5973]-5973-15',
                    for_attribute: 'mce-group[5973]-5973-15',
                    name: 'Investigations Today',
                    interest_id: '6352181190'
                },
                {
                    value: 65536,
                    name_attribute: 'group[5973][65536]',
                    id: 'mce-group[5973]-5973-16',
                    for_attribute: 'mce-group[5973]-5973-16',
                    name: 'Public Affairs Energy Realism',
                    interest_id: 'dfbbf01030'
                },
                {
                    value: 131072,
                    name_attribute: 'group[5973][131072]',
                    id: 'mce-group[5973]-5973-17',
                    for_attribute: 'mce-group[5973]-5973-17',
                    name: 'Public Affairs American Civics',
                    interest_id: 'aa91b5c3b2'
                },
                {
                    value: 262144,
                    name_attribute: 'group[5973][262144]',
                    id: 'mce-group[5973]-5973-18',
                    for_attribute: 'mce-group[5973]-5973-18',
                    name: 'Public Affairs Reimagining Healthcare',
                    interest_id: '3aba243860'
                },
                {
                    value: 524288,
                    name_attribute: 'group[5973][524288]',
                    id: 'mce-group[5973]-5973-19',
                    for_attribute: 'mce-group[5973]-5973-19',
                    name: 'RealClear Pennsylvania',
                    interest_id: 'b64a8082f3'
                },
                {
                    value: 2097152,
                    name_attribute: 'group[5973][2097152]',
                    id: 'mce-group[5973]-5973-20',
                    for_attribute: 'mce-group[5973]-5973-20',
                    name: 'Public Affairs Trustworthy Elections',
                    interest_id: '839e6a4969'
                },
                {
                    value: 4194304,
                    name_attribute: 'group[5973][4194304]',
                    id: 'mce-group[5973]-5973-21',
                    for_attribute: 'mce-group[5973]-5973-21',
                    name: 'Public Affairs Grand Strategy',
                    interest_id: '6aa7d6bdec'
                },
                {
                    value: 8388608,
                    name_attribute: 'group[5973][8388608]',
                    id: 'mce-group[5973]-5973-22',
                    for_attribute: 'mce-group[5973]-5973-22',
                    name: 'RealClear Florida',
                    interest_id: '98754a303f'
                }
            ],
        };
    },
    created: function () { //runs after an instance is created

        // initial load of data and bootstraping
        (async () => {

            this.loading_data = true;
            await this.get_issue_data();
            await this.get_issue_data_basic();
            await this.get_issue_list(); 
            this.loading_data = false;

            await this.loadAllSectionPosts();

            // post loading data and boostraping run other logic
            this.$nextTick(() => {

                this.getQueryParams(window.location.href);

                if (this.featured_story) {
                    this.scrollTo('featured-story-' + this.featured_story.id)
                } else if (this.options) {
                    this.scrollTo(this.options)
                }

                $('#read_more').on('click', this.loadSummary);
                $('#read_less').on('click', this.loadSummary);
                
            });

        })();
    },
    mounted: function () {

        // if(window.location.href.indexOf('american_civics') > 0 ){
        //     (function (a, c, s, u){'Insticator'in a || (a.Insticator={ad:{loadAd: function (b){Insticator.ad.q.push(b)}, q: []}, helper:{}, embed:{}, version: "4.0", q: [], load: function (t, o){Insticator.q.push({t: t, o: o})}}); var b=c.createElement(s); b.src=u; b.async=!0; var d=c.getElementsByTagName(s)[0]; d.parentNode.insertBefore(b, d)})(window, document, 'script', '//d3lcz8vpax4lo2.cloudfront.net/ads-code/5ced65ea-c985-45f6-a119-08287af45f30.js')
        //     Insticator.load("em",{id : "980f3cb3-4221-4792-9008-ac9e379f4fec"})
        // }
    },

    computed: {

        show_submit: function() {
            if (this.confirm_tos) {
                this.mailchimp_newsletter_signup_button_enabled = 'mailchimp_newsletter_signup_button_enabled'
            } else {
                this.mailchimp_newsletter_signup_button_enabled = ''
            }
        },

        summary_lead_text: function() {
            return this.summary_lead + '<span id="read_more" @click="loadSummary">(Read More...) </span></p>'
        },

        menu_list_sub_issues: function(){

            return this.issue.sub_issues.filter((i, x) => {
                if(i.on_sub_issues_menu == 1){
                    return i;
                }
            });
        },

        /**
         * Converts array of objects structure to array or arrays with two objects each
         * Allows to more easily display content as two columns
         */
        twoColStructure(){

            if(['entrepreneurship','realclearunicorns'].indexOf(this.issue.slug) === -1){
                return [];
            }

            let sections = [];
            let group = [];

            for (let i = 0; i < this.issue.sections.length; i++) {

                group.push(this.issue.sections[i]);
                
                if(group.length == 2 || (i+1) == this.issue.sections.length ){
                    sections.push(group);
                    group = [];
                }
            }

            return sections;
        },

    },
    directives: {
        focus: {
            // directive definition
            inserted: function (el) {
                el.focus()
            },
        },
    },

    methods: {

        setFilteredPosts(sections){
            this.$set(this.issue, 'sections', sections);
        },

        get_issue_data(){

            return new Promise((resolve, reject) => {

                //get public affairs data AND initialize Vue App
                $.ajax({
                    url: data_url + '?v=' + cache_bust,
                    dataType: 'JSON',
                    contentType: 'application/json',
                    success: (data) => {
                        data = this.parseIssueData(data);
                        this.issue = data;
                        console.log("PA ISSUE DATA", data);
                        // get_issue_list();
                        resolve(data);


                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        reject(errorThrown);
                    },
                });

            });
        },

        get_issue_data_basic(){

            return new Promise((resolve, reject) => {

                //get public affairs data AND initialize Vue App
                $.ajax({
                    url: index_issue_basic + '?v=' + cache_bust,
                    dataType: 'JSON',
                    contentType: 'application/json',
                    success: (data) => {
                        data = this.parseIssueData(data);
                        this.issue_basic = data;
                        console.log("PA ISSUE DATA BASIC", data);
                        // get_issue_list();
                        resolve(data);

                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        reject(errorThrown);
                    },
                });

            });
        },

        get_issue_list() {

            return new Promise((resolve, reject) => {

                //get public affairs data AND initialize Vue App
                $.ajax({
                    url: all_issues_url + '?v=' + cache_bust,
                    dataType: 'json',
                    success: (data) => {
                        this.all_issues = data;
                        console.log("PA ISSUES LIST", data);
                        // Start App
                        // init_vue();
                        resolve(data);
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        // init_vue();
                        reject(errorThrown);
                    },
                });

            });
        },

        parseIssueData(issue){

            if(typeof issue.summary_lead == 'string' && issue.summary_lead.length > 0){
                issue.summary_lead += '&nbsp;<span id="read_more" > (Read More...) </span></p>';

                if(typeof issue.summary == 'string' 
                    && issue.summary.length > 0 ){
                    var last_p_reg = new RegExp(/(<[\/p>]*)$/i);
                    var show_less = '&nbsp;<span id="read_less">(Show Less) </span></p>';
                    issue.summary = issue.summary.replace(last_p_reg, show_less);
                }
            }

            issue.tags = issue.tags || [];
            issue.tags = issue.tags.filter(function(s, i){
                                        
                        // if these values are here it's a preview so only return the valid ones for preview
                        if(typeof s.status !== 'undefined' && s.status === 1 && s.posts_count > 0){
                            return s;
                        // else if not in preview return all
                        }else if(typeof s.status == 'undefined'){
                            return s;
                        }
                    });

            issue.pa_states = issue.pa_states || [];
            issue.pa_states = issue.pa_states.filter(function(s, i){
                                
                                // if these values are here it's a preview so only return the valid ones for preview
                                if(typeof s.status !== 'undefined' && s.status === 1 && s.posts_count > 0){
                                    return s;
                                // else if not in preview return all
                                }else if(typeof s.status == 'undefined'){
                                    return s;
                                }
                            });

            return issue;
        },

        loadAllSectionPosts(){

            return new Promise((resolve, reject) => {

                let requests = [];

                for (let i = 0; i < this.issue.sections.length; i++) {
                    let slug = this.issue.sections[i].slug;
                    requests.push( this.$http.get(slug + '_posts.json?v=' + cache_bust) );   
                }

                let posts = [];

                this.$http.all(requests)
                .then(res => {

                    for (let x = 0; x < res.length; x++) {
                        if( res[x].data ){
                            this.$set(this.issue.sections[x], 'posts', res[x].data);
                            posts = posts.concat(res[x].data);
                        }
                    }

                    // console.log("ALL POSTS", posts);
                    this.$set(this, 'posts', posts);

                    resolve(res);
                })
                .catch(error => {
                    console.log("FAILED TO LOAD POSTS FOR SECTIONS", error, requests);
                    reject(error);
                });

            });
        },

        /**
         * Returns the proper name for sub issues in listing
         * @param {object} sub_issue 
         * @param {number} index 
         * @returns string
         */
        sub_issue_link_name: function(sub_issue, index){
            
            var name = sub_issue.name;
            if( (index + 1) < this.menu_list_sub_issues.length ){
                name = name+', ';
            }

            return name;
        },

        /**
         * Returns the full relative path to a subissue
         * @param {object} sub_issue 
         * @returns string
         */
        sub_issue_link: function(sub_issue){
            return '/public_affairs/'+this.issue.slug+'/'+sub_issue.slug+'/';
        },

        toggle_submit_button: function () {
            if (this.confirm_tos) {
                this.mailchimp_newsletter_signup_button_enabled = ''
            } else {
                this.mailchimp_newsletter_signup_button_enabled = 'mailchimp_newsletter_signup_button_enabled'
            }
        },

        clear_button: function () {
            this.submitted = false
            this.newsletter_response = false
        },

        valid_email: function (email) {
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
            return emailReg.test(email)
        },

        mailchimp_newsletter_signup: function () {
            if (!this.valid_email(this.mailchimp_newsletter_signup_email)) {
                this.submitting = false
                this.submitted = true
                this.submit_message = 'Please provide a valid email.'
                return
            }

            this.submitting = true
            this.submitted = false
            this.newsletter_response = false


            // point to new api func ##########################################################################################################################
            $.ajax({
            url: window.location.protocol + "//util.realclearpolitics.com/rcmg_users_v2/api.php?method=mc_add_guest_member_to_interests&jsoncallback=?",
            type: "POST",
            crossDomain: true,
            data: {
                'user_email' : this.mailchimp_newsletter_signup_email,
                'zelda'     : "",
                'newsletter_id' : this.issue.mailchimp_audience_id,
                'site': this.getDomain()
            },
            success: function (resp) {
                    var vueThis = this;
                    this.submitting = false
                    this.submitted = true
                    if (resp.success) {
                        if(resp.data.is_unsubscribed){
                            this.user_newsletters = resp.data.newsletters;
                            vueThis.open_mc_embeded_modal();
                            
                        } else {
                            this.newsletter_response = true
                            this.submit_message = 'Success! Thank you for signing up.'
                        }
                        
                    }

                }.bind(this),
                error: function (jqXHR, textStatus) {
                    console.log(jqXHR)
                    console.log(textStatus)
                }.bind(this),
            });
        },

        open_mc_embeded_modal: function () {
            var vueThis = this;
            this.open_mc_embeded_form = true
            //fade mouse animation 5 seconds after modal opens
            setTimeout(function(){
                $('.mouse_scroll').fadeOut();
            }, 5000);
            setTimeout(function(){ //timeout to wait for newsletters printing loop to finish
                vueThis.preselect_user_newsletters();
            }, 200);
            
        },

        close_mc_embeded_modal : function(){
            this.open_mc_embeded_form = false;
        },

        preselect_user_newsletters: function(){
            var newsletters_list = document.querySelectorAll('.mc-modal-container #mc-embedded-subscribe-form li input');
            for (var i = 0; i < newsletters_list.length; i++) {
                var newsletter_id = newsletters_list[i].getAttribute('data-interest-id');
                if (this.mc_user_has_newsletter(newsletter_id)) {
                    newsletters_list[i].checked = true;
                }
            }
        },

        mc_user_has_newsletter: function(newsletter_id){
            for (var i = 0; i < this.user_newsletters.length; i++) {
                if (newsletter_id == this.user_newsletters[i].list_id) {
                    return true;
                }
            }
            return false;
        },

        mc_embedded_submit: function( event ) {
            event.preventDefault(); // prevent default form submit
            this.submitted_form = true; //this makes the form disappear
            this.show_load_spinner = true; //show spinner
            var mc_form = $('.mc-modal-container form'); //select the form
            if ( mc_form.length > 0 ) { //if the form exists
                this.mc_subscribe(mc_form); // run register function
            }
        },

        mc_subscribe: function(mc_form) { // this calls mailchimp
            var vueThis = this;
            $.ajax({
                type        : mc_form.attr('method'),
                url         : mc_form.attr('action').replace('/post?', '/post-json?').concat('&c=?'), //important to make ajax request work from our end
                data        : mc_form.serialize(), //serialize the form data
                cache       : false,
                dataType    : 'json',
                contentType : "application/json; charset=utf-8",
                error       : function(jqXHR, exception ) {
                    var msg = '';
                    if (jqXHR.status === 0) {
                        msg = 'Not connect.\n Verify Network.';
                    } else if (jqXHR.status == 404) {
                        msg = 'Requested page not found. [404]';
                    } else if (jqXHR.status == 500) {
                        msg = 'Internal Server Error [500].';
                    } else if (exception === 'parsererror') {
                        msg = 'Requested JSON parse failed.';
                    } else if (exception === 'timeout') {
                        msg = 'Time out error.';
                    } else if (exception === 'abort') {
                        msg = 'Ajax request aborted.';
                    } else {
                        msg = 'Uncaught Error.\n' + jqXHR;
                    }
                    vueThis.embeded_mc_form_error(msg);
                
                }, //if error occured send email
                success     : function(data) {
                    if (data.result == "success") {
                        vueThis.newsletter_response = true
                        vueThis.submit_message = 'Success! Thank you for signing up.'
                        vueThis.close_mc_embeded_modal();
                    } 
                }
            });
        },

        embeded_mc_form_error: function(error_message){ //this will send an email to tickets in case of an error
            var vueThis = this;
            $.ajax({
            url: window.location.protocol + "//util.realclearpolitics.com/rcmg_users_v2/api.php?method=mc_error_email&jsoncallback=?",
            type: "POST",
            crossDomain: true,
            data: {
                'error_message' : error_message,
                'failure_url'  : window.location.href,
            },
            success: function (resp) {
                if (resp.success) {
                    vueThis.newsletter_response = true
                    vueThis.submit_message = 'Error occured. Please try again later.'
                    vueThis.close_mc_embeded_modal();
                }
                }.bind(this),
                error: function (jqXHR, textStatus) {
                    console.log(jqXHR)
                    console.log(textStatus)
                }.bind(this),
            });
        },

        getDomain: function (){
        var path = window.location.host;
        if(path.substr(0,3)=='www'){
            var per=path.indexOf('.')
            per=per+1;
            path=path.substr(per);
        }
        return path;
        },

        loadSummary: function () {

            this.show_full_summary = !this.show_full_summary

            if (this.show_full_summary) {
                this.summaryLabel = 'Show Less'
            } else {
                this.summaryLabel = 'Show More'
            }
        },

        loadArchives: function () {

            this.page_control++

            this.get_search_results(true)
        },

        display_type: function (item) {

            var type = item.type.replace('public-affair-', '')

            if (type == 'entry') {
                return 'article'
            }
            if (type == 'manual') {
                return 'article'
            }
            return type
        },

        getFeaturedImage: function () {

            if (this.featured_story.promo_feed_image != null) {
                return this.featured_story.promo_feed_image
            } else {
                return this.featured_story.img_url
            }
        },

        checkAll: function () {

            this.filters = []

            if (this.isCheckAll) { // Check all

                for (var key in this.filterTypes) {
                    this.filters.push(this.filterTypes[key])
                }
                this.get_search_results()

            } else {

                this.get_search_results()
            }
        },

        updateCheckall: function () {

            if (this.filters.length === this.filterTypes.length) {

                this.isCheckAll = true
                this.get_search_results()

            } else {

                this.isCheckAll = false
                this.get_search_results()
            }
        },



        inArray: function (needle, haystack) {
            var length = haystack.length
            for (var i = 0; i < length; i++) {
                if (haystack[i] === needle) {
                    return true
                }
            }
            return false
        },

        formatted_item_title: function (input_title) {

            var raw_title = input_title.replace('&#039;', '\'')
            return raw_title.replace('&#039;', '\'')
        },

        get_search_results: function (is_next) {

            var data = {
                'ge_category' : this.issue.name,
                'ge_action' : 'Search',
                'ge_label' : 'PublicAffairs',
                'ge_noninteraction': false,
            };
            send_ga_event(data);
            
            if (typeof is_next === 'undefined') {
                is_next = false;
            }

            if (!is_next) {
                this.page_control = 1;
            }

            this.selectedFilter = '';

            var type_prefix = '';

            Search.fq_override = ''; // Not using currently
            Search.bq_override = ''; // Used to set
            Search.category = '';
            Search.pa_issue_id = '';

            if (this.inside != 'site') {

                type_prefix = 'public-affair-';

                // If you want type of summary or charticle to always be on top:
                //Search.bq_override = "(type:"+type_prefix+"summary)^999 OR (type:"+type_prefix+"charticle)^999";

                // If you want items in "Essential Reading" to always be on top:
                Search.bq_override = '(pa_section_id:2)^999';
            }

            // Read Checked checkboxes value
            for (var key in this.filters) {
                //if(this.filters[key] != 'charticle') {
                this.selectedFilter += type_prefix + this.filters[key] + ' ';
                //}
                if (this.filters[key] == 'article') {
                    this.selectedFilter += type_prefix + 'entry ' + type_prefix + 'manual ';
                }
            }

            if (this.inside != 'site') {
                Search.pa_issue_id = this.inside;
            }

            var raw_doc_types = this.selectedFilter;

            if (raw_doc_types == '') {

                Search.doc_type = '';
                // Clear results and return
                this.archive_items = [];
                this.pagiTotal = 0;
                return;
            }

            var docTypeString = '(' + raw_doc_types.substring(0, raw_doc_types.length - 1) + ')';
            Search.doc_type = docTypeString;

            if (this.search.length === 0) {
                return;
            }

            this.loading_archives = true;

            Search.q = this.search;
            Search.rows = this.archives_per_load;
            Search.offset = (this.page_control - 1) * Search.rows;
            var search_endpoint = Search.build_GET_url(Search.q);

            //Get search results from Solr
            $.ajax({
                url: search_endpoint,
                dataType: 'json',
                success: (data) => {
                    archive_data = data.response; //get new set of data

                    var total_items = archive_data.numFound;
                    // Start App
                    this.show_pagi = true;
                    this.pagiTotal = total_items;

                    if (!is_next) {
                        this.archive_items = [];
                    }

                    for (var i = 0; i < archive_data.docs.length; i++) {
                        var item = archive_data.docs[i];

                        var title = this.formatted_item_title(item.heading1);

                        var body = item.body;
                        var max_length = 185;
                        var trimmedBody = body.length > max_length ? body.substring(0, max_length - 3) + '...' : body.substring(0, max_length);

                        var type = item.type;

                        var category = '';

                        if (typeof item.category !== 'undefined') {
                            category = item.category;
                        }

                        // Detect if duplicate title. If so, decide whether to keep old or replace with new

                        var overwrite = false;
                        var overwrite_index = 0;

                        for (var j = 0; j < this.archive_items.length; j++) {

                            var existing_item = this.archive_items[j];

                            if (existing_item['title'] == title) {

                                if (existing_item['type'] == type) {
                                    overwrite = true;
                                }
                                if (existing_item['type'] == 'public-affair-entry') {
                                    overwrite = true;
                                }
                                if (existing_item['type'] == 'public-affair-article' && (type == 'public-affair-charticle' || type == 'public-affair-manual')) {
                                    overwrite = true;
                                }
                                if (existing_item['type'] == 'public-affair-manual' && type == 'public-affair-charticle') {
                                    overwrite = true;
                                }
                            }

                            if (overwrite) {
                                overwrite_index = j;
                                break;
                            }
                        }

                        if (overwrite) {

                            this.archive_items[overwrite_index]['title'] = title;
                            this.archive_items[overwrite_index]['type'] = type;
                            this.archive_items[overwrite_index]['category'] = category;
                            this.archive_items[overwrite_index]['url'] = item.content_url;
                            this.archive_items[overwrite_index]['excerpt'] = trimmedBody;

                        } else {

                            this.archive_items.push({
                                title: title,
                                type: type,
                                category: category,
                                url: item.content_url,
                                excerpt: trimmedBody,
                            });
                        }
                    }

                    this.loading_archives = false;
                },

                error: (jqXHR, textStatus, errorThrown) => {
                    this.loading_archives = false;
                },
            }); //end AJAX call to hit Solr and get Search Results

        }, //end get searc results vue method

        featured_post_exists: function (id) {
            
            var post = this.findItem(this.posts, id);

            if (post) {
                this.featured_story = post;
            }
        },

        findItem: function (collection, id) {

            let index = collection.map(x => x.id).indexOf(id);

            if( index !== -1 ){
                return collection[index];
            }

            return false;
        },

        getQueryParams: function (url_string) {

            var c = window.Utils.get_query_param('id');
            var featured_id = window.Utils.get_query_param('featured_post');

            if (c !== null) {
                this.options = parseInt(c);
                this.video_embed_item_exists(this.options);
            }

            if (featured_id !== null) {
                this.featured_post_exists(parseInt(featured_id));
            }

            this.getEadSection(url_string);

        },

        getEadSection: function (url) {
            this.issue.sections.filter((section) => {
                if (url.indexOf(section.slug) > -1 && url.indexOf(this.issue.slug)) {
                    this.isThemeSection = true;
                    this.themeSection = section;
                }
            });
        },

        video_embed_item_exists: function (id) {

            let index = this.issue.sections.map(x => x.slug).indexOf('multimedia');

            if(index == -1){
                return;
            }
            
            let featured_video = this.findItem(this.issue.sections[index].posts, id);

            if (featured_video) {
                this.display_video_embed(featured_video);
                this.scrollTo(id);
            }

        },

        display_video_embed: function (post) { // will display modal overlay iframe

            if (typeof post.embed_expanded == 'undefined') {
                this.$set(post, 'embed_expanded', false);
            }

            post.embed_expanded = !post.embed_expanded;
            
            this.overlay_is_active = true;
        },

        scrollTo: function (element) {

            this.$nextTick(() => {
                setTimeout(() => {
                    if ($('#' + element).length > 0) {
                        $('html, body').animate({
                            scrollTop: $('#' + element).offset().top,
                        }, 'slow')
                    }
                }, 500);
            });
        },
    },
}
</script>

<style lang="scss">
#mc_embed_signup{
    background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif; width:100%;}

.content{
    &.entrepreneurship,
    &.realclearunicorns {
        .summary-wrapper{
            margin-bottom: 0em;
        }

        .state-selector-widget{

            .two-col-wrapper.filter-input{
                margin-bottom: .5rem;
                margin-top: -12.5px;
            }
        }
    }

    .two-col-wrapper{
        .col{
            &.two-col-limit{
                @media screen and (min-width: 768px) {
                    max-width: 50%;
                }
            }
        }
    }

    &.sub-issue{
        .two-col-wrapper-sub-issue{
            .item {
                .item-author{
                    color: #000;
                }
            }
        }
    }
}

 /* MailChimp Modal start */

/* 
CSS in here is just for the MC modal
added MailChimp's css here since their cdn would fail sometimes
*/

/* MailChimp Form Embed Code - Classic - 12/17/2015 v10.7 */
#mc_embed_signup form {display:block; position:relative; text-align:left; padding:10px;}
#mc_embed_signup h2 {font-weight:bold; padding:0; margin:15px 0; font-size:1.4em;}
#mc_embed_signup input {border: 1px solid #ABB0B2; -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px;}
#mc_embed_signup input[type=checkbox]{-webkit-appearance:checkbox;}
#mc_embed_signup input[type=radio]{-webkit-appearance:radio;}
#mc_embed_signup input:focus {border-color:#333;}
#mc_embed_signup .button {clear:both; background-color: #59b9fd; border: 0 none; border-radius:4px; transition: all 0.23s ease-in-out 0s; color: #FFFFFF; cursor: pointer; display: inline-block; font-size:15px; font-weight: normal; height: 32px; line-height: 32px; margin: 0 5px 10px 0; padding: 0 22px; text-align: center; text-decoration: none; vertical-align: top; white-space: nowrap; width: 100%;}
#mc_embed_signup .button:hover {background-color:#777;}
#mc_embed_signup .small-meta {font-size: 11px;}
#mc_embed_signup .nowrap {white-space:nowrap;}

#mc_embed_signup .mc-field-group {clear:left; position:relative; width:96%; padding-bottom:3%; min-height:50px;}
#mc_embed_signup .size1of2 {clear:none; float:left; display:inline-block; width:46%; margin-right:4%;}
* html #mc_embed_signup .size1of2 {margin-right:2%; /* Fix for IE6 double margins. */}
#mc_embed_signup .mc-field-group label {display:block; margin-bottom:3px;}
#mc_embed_signup .mc-field-group input {display:block; width:100%; padding:8px 0; text-indent:2%;}
#mc_embed_signup .mc-field-group select {display:inline-block; width:99%; padding:5px 0; margin-bottom:2px;}

#mc_embed_signup .datefield, #mc_embed_signup .phonefield-us{padding:5px 0;}
#mc_embed_signup .datefield input, #mc_embed_signup .phonefield-us input{display:inline; width:60px; margin:0 2px; letter-spacing:1px; text-align:center; padding:5px 0 2px 0;}
#mc_embed_signup .phonefield-us .phonearea input, #mc_embed_signup .phonefield-us .phonedetail1 input{width:40px;}
#mc_embed_signup .datefield .monthfield input, #mc_embed_signup .datefield .dayfield input{width:30px;}
#mc_embed_signup .datefield label, #mc_embed_signup .phonefield-us label{display:none;}

#mc_embed_signup .indicates-required {text-align:right; font-size:11px; margin-right:4%;}
#mc_embed_signup .asterisk {color:#e85c41; font-size:150%; font-weight:normal; position:relative; top:5px;}     
#mc_embed_signup .clear {clear:both;}

#mc_embed_signup .mc-field-group.input-group ul {margin:0; padding:5px 0; list-style:none;}
#mc_embed_signup .mc-field-group.input-group ul li {display:block; padding:3px 0; margin:0;}
#mc_embed_signup .mc-field-group.input-group label {display:inline;}
#mc_embed_signup .mc-field-group.input-group input {display:inline; width:auto; border:none;}

#mc_embed_signup div#mce-responses {float:left; top:-1.4em; padding:0em .5em 0em .5em; overflow:hidden; width:90%; margin: 0 5%; clear: both;}
#mc_embed_signup div.response {margin:1em 0; padding:1em .5em .5em 0; font-weight:bold; float:left; top:-1.5em; z-index:1; width:80%;}
#mc_embed_signup #mce-error-response {display:none;}
#mc_embed_signup #mce-success-response {color:#529214; display:none;}
#mc_embed_signup label.error {display:block; float:none; width:auto; margin-left:1.05em; text-align:left; padding:.5em 0;}

#mc-embedded-subscribe {clear:both; width:auto; display:block; margin:1em 0 1em 5%;}
#mc_embed_signup #num-subscribers {font-size:1.1em;}
#mc_embed_signup #num-subscribers span {padding:.5em; border:1px solid #ccc; margin-right:.5em; font-weight:bold;}

#mc_embed_signup #mc-embedded-subscribe-form div.mce_inline_error {display:inline-block; margin:2px 0 1em 0; padding:5px 10px; background-color:rgba(255,255,255,0.85); -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px; font-size:14px; font-weight:normal; z-index:1; color:#e85c41;}
#mc_embed_signup #mc-embedded-subscribe-form input.mce_inline_error {border:2px solid #e85c41;}

.mc-modal-container #mc_embed_signup {
    background: #f5f5f5;
}

.mc-modal-container, .mc-modal-underlay {
    display: block;
}

.mc-modal-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    background: #f5f5f5;
    border-radius: 10px;
    width: 300px;
    overflow: hidden;
}

.mc-modal-underlay {
    position: fixed;
    background: #00000057;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.mc-modal-container .close-icon{
    width: 15px;
    height: 15px;
    position: absolute;
    cursor: pointer;
}

.mc-modal-container .right {
    right: 10px;
    top: 10px;
}

.mc-modal-container .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
}

.mc-modal-container ul {
    max-height: 270px;
    overflow-y: auto;
}

.mc-modal-container .subscribe_txt {
    font-weight: bold;
    color: #008e00;
    font-size: 1.2em;
    text-align: center;
}
.mc-modal-container .subscribe_txt.error {
    color: #e85c41;
}

.mc-modal-preselect-msg {
    font-size: 0.8em;
    text-align: center;
}

#mc_embed_signup .button:hover {
    background: #409ada !important;
}

@media only screen and (max-width: 414px) {
    .mc-modal-container {
        width: 280px;
    }
}

/* scroll down animation */
.mouse_scroll *, 
.mouse_scroll *:before, 
.mouse_scroll *:after {
    -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box;
}
  
.mouse_scroll {
    display: block;
    position: absolute;
    right: 0;
    bottom: 50%;
    transform: translate(10%, 50%);
}
  
.m_scroll_arrows {
    display: block;
    width: 5px;
    height: 5px;
    -ms-transform: rotate(45deg); /* IE 9 */
    -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
        
    border-right: 2px solid #aaa;
    border-bottom: 2px solid #aaa;
    margin: 0 0 3px 4px;

    width: 16px;
    height: 16px;
}
  
.one {
    margin-top: 1px;
}
  
.one, .two, .three {
    -webkit-animation: mouse-scroll 1s infinite;
    -moz-animation: mouse-scroll 1s infinite;
    animation: mouse-scroll 1s infinite;
}
  
.one {
    -webkit-animation-delay: .1s;
    -moz-animation-delay: .1s;
    -webkit-animation-direction: alternate;

    animation-direction: alternate;
    animation-delay: alternate;
}
  
.two {
    -webkit-animation-delay: .2s;
    -moz-animation-delay: .2s;
    -webkit-animation-direction: alternate;

    animation-delay: .2s;
    animation-direction: alternate;
    margin-top: -6px;
}
  
.three {
    -webkit-animation-delay: .3s;
    -moz-animation-delay: .3s;
    -webkit-animation-direction: alternate;

    animation-delay: .3s;
    animation-direction: alternate;
    margin-top: -6px;
}
  
.mouse {
    height: 42px;
    width: 24px;
    border-radius: 14px;
    transform: none;
    border: 2px solid #aaa;
    top: 170px;
}
  
.wheel {
    height: 5px;
    width: 2px;
    display: block;
    margin: 5px auto;
    background: #aaa;
    position: relative;

    height: 4px;
    width: 4px;
    border: 2px solid #aaa;
    -webkit-border-radius: 8px;
    border-radius: 8px;
}
  
.wheel {
    -webkit-animation: mouse-wheel 0.6s linear infinite;
    -moz-animation: mouse-wheel 0.6s linear infinite;
    animation: mouse-wheel 0.6s linear infinite;
}
  
@-webkit-keyframes mouse-wheel{
    0% {
    opacity: 1;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
    }
  
    100% {
        opacity: 0;
        -webkit-transform: translateY(6px);
        -ms-transform: translateY(6px);
        transform: translateY(6px);
    }
}
@-moz-keyframes mouse-wheel {
    0% { top: 1px; }
    25% { top: 2px; }
    50% { top: 3px;}
    75% { top: 2px;}
    100% { top: 1px;}
}
@-o-keyframes mouse-wheel {
    0% { top: 1px; }
    25% { top: 2px; }
    50% { top: 3px;}
    75% { top: 2px;}
    100% { top: 1px;}
}
@keyframes mouse-wheel {
    0% { top: 1px; }
    25% { top: 2px; }
    50% { top: 3px;}
    75% { top: 2px;}
    100% { top: 1px;}
}
  
@-webkit-keyframes mouse-scroll {
    0%   { opacity: 0;}
    50%  { opacity: .5;}
    100% { opacity: 1;}
}
@-moz-keyframes mouse-scroll {
    0%   { opacity: 0; }
    50%  { opacity: .5; }
    100% { opacity: 1; }
}
@-o-keyframes mouse-scroll {
    0%   { opacity: 0; }
    50%  { opacity: .5; }
    100% { opacity: 1; }
}
@keyframes mouse-scroll {
    0%   { opacity: 0; }
    50%  { opacity: .5; }
    100% { opacity: 1; }
}
/* MailChimp Modal end */

</style>